import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  SkipSelf,
} from '@angular/core';
import { tuiPure } from '@taiga-ui/cdk';
import { BehaviorSubject } from 'rxjs';
import { AsyncPipe, NgTemplateOutlet } from '@angular/common';

import { AlertService } from '@shared/services/alert.service';
import { Clipboard } from '@angular/cdk/clipboard';

import { DomSanitizer } from '@angular/platform-browser';
import {
  PolymorpheusContent,
  PolymorpheusModule,
} from '@tinkoff/ng-polymorpheus';
import { CONTROL_SERVICE_PROVIDER } from '@shared/providers/control.provider';
import { ControlService } from '@shared/services/control.service';
import { TuiButtonModule } from '@taiga-ui/core';
import { TuiIconModule } from '@taiga-ui/experimental';
import { ControlRecord } from '../../../../types/control';

@Component({
  selector: 'app-control-record',
  imports: [
    AsyncPipe,
    NgTemplateOutlet,
    TuiButtonModule,
    PolymorpheusModule,
    TuiIconModule,
  ],
  templateUrl: './control-record.component.html',
  styleUrl: './control-record.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class ControlRecordComponent {
  @Input()
  record: ControlRecord;

  @Input()
  index: number;

  @Input() errorAction!: PolymorpheusContent<unknown>;

  @Output() solved = new EventEmitter();

  extended$ = new BehaviorSubject<boolean>(false);
  constructor(
    @SkipSelf()
    @Inject(CONTROL_SERVICE_PROVIDER)
    private readonly declarationControl: ControlService,
    private readonly alert: AlertService,
    private readonly clipboard: Clipboard,
    private readonly sanitizer: DomSanitizer,
  ) {}

  markAsSolved() {
    this.solved.emit();
  }

  copyIndexes() {
    if (this.record.items?.length) {
      const indexes = this.record.items.map(obj => {
        const [index] = Object.values(obj);
        return index;
      });
      const value = indexes.join(',').replace(/ /g, '');
      this.clipboard.copy(value);
      this.alert.showInfo('Скопировано');
    }
  }

  @tuiPure
  getBorderColorClassByErrorType(record: ControlRecord) {
    switch (record.message.type) {
      case 'error':
        return 'border-red-600';
      case 'warning':
        return 'border-yellow-400';
      case 'info':
        return 'border-blue-400';
    }
  }

  getIndexFromItem(item: Record<string, number>) {
    return Object.values(item).at(0);
  }

  showElementField(index: number | undefined) {
    if (index === null || index === undefined) {
      return;
    }
    this.declarationControl.showField(this.record, index - 1);
  }

  @tuiPure
  sanitizedHtml(text: string) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  showField() {
    this.declarationControl.showField(this.record);
  }
}
